import { useUser } from "lib/user";

export const useHasCurrentMembership = (): boolean => {
  const { membership } = useUser();

  return !!(membership && membership?.id !== "none:none");
};
